<xemex-chart
  [datasets]="chartDatasets()"
  [labels]="chartLabels()"
  [note]="chartNote()"
  [badge]="chartBadge()"
  [loading]="telemetryStore.isLoadingDeviceTelemetry()"
  [options]="chartOptions"
></xemex-chart>
